export default __webpack_public_path__ + "static/media/forwardArrowDisabled.67a2eb28.svg";